





let param = getUrlParams(window.location.href);
import XButton from 'vux/src/components/x-button/index.vue'

import Edit from "../edit/edit.vue";
import { getVuxUrlQuery, createRequest, getUrlParams } from "../../utils/utils";
import { STORAGE_KEY } from '../../utils/define';
import HumanList from '../HumanList/HumanList.vue';
import { modelView, qaList,config,cardView} from '../../api/api';
import MyVideo from '../myVideo/myVideo';
export default {
name: "QAComponent",
components: {
XButton,
Edit,
HumanList,
MyVideo,
},
props: {
addSaveRouterIs: Number,
modelID:Number,
cardTypeIs:String,










},
data() {
return {
data: [],
spareList: [],
total: 0,
spareTotal: 0,
modelViewId:0,
actionList:[],
currentVideoUrl:'',
showVideo:false,
tabList:[
{
id:1,
name:'数字人形象',
is_show:1
},
{
id:2,
name:'互动设置',
is_show:2
},
{
id:3,
name:'互动问题',
is_show:0
},
]
};
},
created() {

console.log('%c⧭', 'color: #8c0038;font-size:100px', this.cardTypeIs,"qa")
this.modelViewId = this.modelID || localStorage.getItem(STORAGE_KEY.MODEL_ID);
this.getQAlist();
this.getFigureList();



},
mounted() {
console.log('get qa list----------',this.cardTypeIs)
document.title= '互动问题'
},
beforeDestroy() {},
methods: {

onSaveGetList() {
this.getQAlist();
},

getQAlist() {

if(this.cardTypeIs == '3d')
{

modelView(this.modelViewId).then(res=>{
console.log('model View',res)
let gender = res.data.image.gender
this.$emit('onSpareInfoChange',res.data)
config(res.data.image.version).then(res=>{
this.actionList = res.data.action_map[String(gender)]
})
qaList(this.modelViewId,this.cardTypeIs).then(res=>{
this.data = res.data.data;
this.total = res.data.total;

})
})
}
else if(this.cardTypeIs == '2d')
{
cardView(this.modelViewId).then(res=>{
console.log('model--- View',res)
let gender = res.data.card.gender
this.$emit('onSpareInfoChange',res.data)
config(res.data.card.version).then(res=>{
this.actionList = res.data.action_map[String(gender)]
})
qaList(this.modelViewId,this.cardTypeIs).then(res=>{
this.data = res.data.data;
this.total = res.data.total;

})
})
}
},

getFigureList() {
console.log('--------------------------set QA getFigureList')
createRequest(
"get",
"applet/user/image/list",
{ page: 1, num: 20, status: 3 },
(res) => {
console.log("%c⧭", "color: #d90000", res.data);
if (res.code == 200) {
this.spareList = res.data.data;
this.spareTotal = res.data.total;
} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
}
);
},

onDelectVal(e, i) {
console.log("%c⧭", "color: #006dcc", e, i);
this.data.splice(i, 1);
console.log("%c⧭", "color: #1d3f73", this.data);
createRequest("post", "applet/webview/qa/del", { id: e }, (res) => {
console.log("%c⧭", "color: #d90000", res.data);
if (res.code == 200) {
this.$vux.toast.show({
type: "text",
text: "删除成功",
});
this.getQAlist();







} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
});
},
onBack(){
console.log('----QA back')
this.$emit("onBack","preview")
},
selectSpare(data){
console.log('user select spare',data)
this.modelViewId = data.id
this.getQAlist()
}
},
watch: {
addSaveRouterIs(value) {
this.getQAlist();
},
modelID(value)
{
if(this.modelViewId != value){
this.modelViewId = value
console.log('%c⧭', 'color: #7f2200', value)
this.getQAlist()
}

}
},
};



// WEBPACK FOOTER //
// ./src/myComponents/QAComponent/QAComponent.vue